import { createUrlContext } from './create-url';
import { type RouteStateProps } from './create-url/create-url';
import { normalizeUrl } from './create-url/utils/normalize-url';
import { parseUrlContext } from './parse-url';

export interface RouterURLParams {
  routeState: RouteStateProps;
  location: Location;
}

const routerProxyCategory = (
  indexName: string,
  region: string,
  categoryFiltersLabel?: {},
  algoliaFacetsObject?: {}
) => ({
  router: {
    cleanUrlOnDispose: false,
    writeDelay: 600,
    createURL({ location, routeState }: RouterURLParams) {
      const { href, sponsorsParams } = normalizeUrl(location);
      let createdUrl = createUrlContext(
        {
          ...location,
          href,
          pathname: location.pathname,
          origin: location.origin,
        },
        routeState,
        indexName,
        region,
        categoryFiltersLabel,
        algoliaFacetsObject
      );

      if (sponsorsParams) {
        createdUrl += createdUrl.includes('?') ? '&' : '?';
        createdUrl += sponsorsParams;
      }

      return createdUrl;
    },
    parseURL({ location }: RouterURLParams) {
      const { href } = normalizeUrl(location);

      return parseUrlContext(
        { ...location, href },
        indexName,
        region,
        categoryFiltersLabel,
        algoliaFacetsObject
      );
    },
  },
});

export default routerProxyCategory;
